import type { AnchorHTMLAttributes, ReactNode } from "react";
import type { ButtonVariant } from "./Button.js";

interface ButtonLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  variant?: ButtonVariant;
  children: ReactNode;
}

/** A real link with the shared button appearance for navigation actions. */
export function ButtonLink({ variant = "secondary", className = "", children, ...props }: ButtonLinkProps) {
  return (
    <a className={`mmm-btn mmm-btn--${variant} ${className}`.trim()} {...props}>
      {children}
    </a>
  );
}
